import AppLayout from "app-layout";
import MediaLandingNews from "component/mediaLanding/mediaLandingNews/mediaLandingNews";
import PicturesAndVideos from "component/mediaLanding/picturesAndVideos/PicturesAndVideos";
// import { API_BASE_URL } from "configs/AppConfig";
import React, { useEffect, useRef } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
// import { SWRConfig } from "swr";
// import { I18nProvider } from "../lang";
import About from "./about/About";
import AllVersions from "./allVersions/AllVersions";
import Calendar from "./calendar/Calendar";
import ContactUs from "./contactUs/ContactUs";
import Data from "./data/Data";
import DataRequest from "./dataRequest/DataRequest";
import Home from "./home/Home";
import MediaLanding from "./mediaLanding/MediaLanding";
import Microfilm from "./microfilm/Microfilm";
import Prices from "./prices/Prices";
// import RegistrationSubscription from "./registrationSubscription/RegistrationSubscription";
import Related from "./related/Related";
import ServicesTools from "./servicesTools/ServicesTools";
import Versions from "./versions/Versions";
// import MediaLandingNewsItem from "component/mediaLanding/mediaLandingNewsItem/MediaLandingNewsItem";
import ProtectedRoute from "auth/components/ProtectedRoute/protected-route";
import Magazine from "component/mediaLanding/magazine/Magazine";
import MediaDetails from "component/mediaLanding/mediaDetails/MediaDetails";
import { useDispatch } from "react-redux";
import { REQUEST_LANG } from "redux/constants/Lookup";
import Infograph from "./Infograph/Infograph";
import Login from "./Login/Login";
import WhatsNew from "./Whatsnew/Whatsnew";
import AdvancedSearchPage from "./advanceSearchPage";
import DataDetails from "./data/DataDetails";
import DataVisualization from "./data/DataVisualization";
import ExternalTrade from "./externalTrade/ExternalTrade";
import NewsDetails from "./news/NewsDetails";
import ServiceDetails from "./servicesTools/ServiceDetails";
import SubjectSearch from "./subjectSearch";
import SubscribeForm from "./subscribeForm/subscribeForm";
import ForgetPass from "./forget-pass";
import ResetCode from "./forget-pass/components/reset-code";
import NationalCenter from "./nationalCenter/NationalCenter";
import Vision from "component/about/vision/Vision";
import Boss from "component/about/boss/Boss";
import OrganizationalChart from "component/about/organizationalChart/OrganizationalChart";
import History from "component/about/history/History";
import Laws from "component/about/laws/Laws";
import Sitemap from "./sitemap/Sitemap";
import ProtectedExternalTradeRoute from "auth/components/ProtectedRoute/protected-external-trade-route";
import ExternalTradePaid from "./external-trade-paid";
import Profile from "./profile";
import Newsletters from "./newsletters";
import Notfound from "./notfound";
import Verification from "./Verification";
import ForgetPassword from "./forget-pass/components/forget-password";
import ResetPass from "./forget-pass/components/reset-pass";

const Views = () => {
  const dispatch = useDispatch();
  const initRef = useRef(false);
  useEffect(() => {
    if (initRef.current === false) {
      dispatch({ type: REQUEST_LANG });
      initRef.current = true;
    }
  }, []);
  return (
    <Routes>
      <Route exact path="/" element={<Navigate to={`/home`} replace />} />
      <Route exact path={`/`} element={<AppLayout />}>
        <Route path="/register" element={<SubscribeForm />} />
        <Route path="/home" element={<Home />} />
        <Route path="/sitemap" element={<Sitemap />} />
        <Route path="/subject/search/:id" element={<SubjectSearch />} />
        <Route path="/data" element={<Data />} />
        <Route path="/infograph/:id" element={<Infograph />} />
        <Route
          path="/data/mainSubject/:id/subSubject/:subId"
          element={<DataDetails />}
        />
        <Route
          path="/data/mainSubject/:id/subSubject/:subId/data-visualization/:indicatorId"
          element={<DataVisualization />}
        />
        <Route path="/servicestools" element={<ServicesTools />} />
        <Route path="/servicestools/:id" element={<ServiceDetails />} />
        <Route path="/calendar" element={<Calendar />} />
        <Route path="/prices" element={<Prices />} />
        {/* <Route
            path="/registrationsubscription"
            element={<RegistrationSubscription />}
          /> */}
        <Route path="/login" element={<Login />} />
        <Route
          path="/profile"
          element={
            <ProtectedRoute>
              <Profile />
            </ProtectedRoute>
          }
        />
        <Route path="/forgetPass" element={<ForgetPass />} />
        <Route path="/resetCode/:id" element={<ResetCode />} />
        <Route path="/forgetPass/:id" element={<ForgetPassword />} />
        <Route path="/resetPass/:id" element={<ResetPass />} />
        <Route
          path="/datarequest"
          element={
            <ProtectedRoute>
              <DataRequest />
            </ProtectedRoute>
          }
        />
        <Route
          path="/newsletters"
          element={
            <ProtectedRoute>
              <Newsletters />
            </ProtectedRoute>
          }
        />
        <Route
          path="/microfilm"
          element={
            <ProtectedRoute>
              <Microfilm />
            </ProtectedRoute>
          }
        />
        <Route
          path="/nationalCenter"
          element={
            // <ProtectedRoute>
              <NationalCenter />
            // </ProtectedRoute>
          }
        />
        <Route path="/advanced-search/" element={<AdvancedSearchPage />} />

        <Route
          exact
          path="mediaLanding"
          element={
            <Navigate
              to={`/mediaLanding/${
                window.location.pathname.includes("/news")
                  ? "news"
                  : window.location.pathname.includes("mediaLanding/media")
                  ? "media"
                  : window.location.pathname.includes("/magazine")
                  ? "magazine"
                  : "news"
              }`}
              replace
            />
          }
        />
        <Route path="/mediaLanding" element={<MediaLanding />}>
          <Route exact path="news" element={<MediaLandingNews />} />
          <Route path="news/:id" element={<NewsDetails />} />
          <Route path="media" element={<PicturesAndVideos />} />
          <Route path="media/:id" element={<MediaDetails />} />
          {/* <Route path="statistics" element={<MediaLandingNewsItem />} /> */}
          <Route path="magazine" element={<Magazine />} />
        </Route>

        <Route
          exact
          path="about"
          element={<Navigate to={`/about/vision-mission`} replace />}
        />
        <Route path="/about" element={<About />}>
          <Route exact path="vision-mission" element={<Vision />} />
          <Route path="chairman-word" element={<Boss />} />
          <Route
            path="organizaitional-structure"
            element={<OrganizationalChart />}
          />
          <Route path="device-history" element={<History />} />
          <Route path="laws-frameworks" element={<Laws />} />
        </Route>

        <Route path="/contact" element={<ContactUs />} />
        <Route path="/related" element={<Related />} />
        <Route path="/publications" element={<AllVersions />} />
        <Route path="/publications/:id" element={<Versions />} />
        <Route path="/new" element={<WhatsNew />} />
        <Route
          path="/external-trade"
          element={
            <ProtectedExternalTradeRoute>
              <ExternalTrade />
            </ProtectedExternalTradeRoute>
          }
        />
        <Route path="/external-trade-paid" element={<ExternalTradePaid />} />
        <Route path="/verification/:codeId/:userId" element={<Verification />} />
        <Route path="*" element={<Notfound />} />
      </Route>
    </Routes>
  );
};

export default React.memo(Views);
